import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../../../atoms/icon";
import { copyToClipboard } from "../../../../../utils/utils";
import { GA } from "../../../../../../integrations";

import styles from "./styles.m.css";

export class SocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      showCopiedModal: false
    };
    this.hanldeAction = this.hanldeAction.bind(this);
  }

  handleClick(args) {
    GA.customEvent("Share Click", args, this.props.story.id);
    try {
      if (copyToClipboard(this.props.fullUrl)) {
        this.setState({
          showCopiedModal: true
        });

        setTimeout(() => {
          this.setState({
            showCopiedModal: false
          });
        }, 3000);
      } else {
        // how to convey failure to user
      }
    } catch (err) {
      console.log(err.message);
    }
  }

  hanldeAction(args) {
    const { handleClickView } = this.props;
    GA.customEvent("Share Click", args, this.props.story.id);
    if (args === "comments") handleClickView();
  }

  handleOnShare = () => {
    const { story } = this.props;
    if (navigator.share) {
      navigator
        .share({
          title: `${story.headline}`,
          text: `${story.subheadline}`,
          url: story.url
        })
        .then(() => {
          console.log("Successfully shared");
          this.hanldeAction("more share");
        })
        .catch(error => {
          console.error("Something went wrong sharing the blog", error);
        });
    }
  };

  render() {
    const { fbUrl, twitterUrl, mailtoUrl, handleShare, className, story } = this.props;
    const subheadline = ` ${story.subheadline} `;
    const whatsApp = `https://api.whatsapp.com/send?text=${encodeURIComponent(subheadline)}`.concat(
      encodeURIComponent(story.url)
    );
    let bottomtext =
      " %0a %0a முக்கியச் செய்திகள், சிறப்புப் பேட்டிகள், அலசல் %0a கட்டுரைகளுக்கு Vikatan App-ஐ டவுன்லோடு செய்ய %0a \n https://vikatan.onelink.me/kbqn/VikatanWhatsApp";
    return (
      <div className={`${className} ${styles["social-share"]}`}>
        <ul className={`${styles["social-share__icons"]}`}>
          <li className={`${styles["social-share__icon"]}`}> Share</li>
          <li
            className={`${styles["social-share__whatsapp"]} ${
              styles["social-share__icon"]
            } social-share__icon--whatsapp`}
          >
            <a
              aria-label="whatsapp share"
              href={`${whatsApp}${encodeURIComponent("?utm_source=mobile&utm_medium=whatsapp")} ${bottomtext}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__whatsapp-icon"]}`}
              onClick={this.hanldeAction.bind(this, "whatsapp")}
            >
              <Icon type="whatsapp" className={`${styles["share-svg"]}`} />
            </a>
          </li>

          <li
            className={`${styles["social-share__icon"]} ${
              styles["social-share__icon--facebook"]
            } social-share__icon--facebook`}
          >
            <a
              aria-label="facebook share"
              href={fbUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__fb-icon"]}`}
              onClick={this.hanldeAction.bind(this, "facebook")}
            >
              <Icon type="facebook-icon" className={`${styles["share-svg"]}`} />
            </a>
          </li>
          <li
            className={`${styles["social-share__icon"]} ${
              styles["social-share__icon-twitter"]
            } social-share__icon--twitter`}
          >
            <a
              aria-label="twitter share"
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__twitter--icon"]}`}
              onClick={this.hanldeAction.bind(this, "twitter")}
            >
              <Icon type="twitter-icon" className={`${styles["share-svg"]}`} />
            </a>
          </li>
          <li
            className={`${styles["social-share__icon"]} ${
              styles["social-share__icon--email"]
            } social-share__icon--email`}
          >
            <a
              aria-label="e-mail share"
              href={mailtoUrl}
              className={`${styles["social-share__link"]} ${styles["social-share__email-icon"]}`}
              onClick={this.hanldeAction.bind(this, "e-mail")}
            >
              <Icon type="email" className={`${styles["share-svg"]}`} />
            </a>
          </li>

          {handleShare && (
            <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--app-share"]}`}>
              <button
                aria-label="Share this"
                onClick={handleShare}
                className={`${styles["social-share__link"]} ${styles["social-share__share-app-share"]} ${
                  styles["social-share__button"]
                }`}
                role="button"
              >
                <Icon type="mobile-share" className={`${styles["share-svg"]}`} />
              </button>
            </li>
          )}

          <li
            className={`${styles["social-share__icon"]} ${styles["social-share__icon-copy"]} social-share__icon--copy`}
          >
            {this.state.showCopiedModal && <span className={styles["copy-modal"]}>Copied story url for sharing</span>}
            <button
              aria-label="show message"
              role="button"
              onClick={this.handleClick.bind(this, "copy")}
              className={`${styles["social-share__link"]} ${styles["social-share__copy-icon"]} ${
                styles["social-share__button"]
              }`}
            >
              <Icon type="clipboard" className={`${styles["share-svg"]}`} />
            </button>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon-newsletter"]}`}>
            <a
              aria-label="more share"
              onClick={() => this.handleOnShare()}
              className={`${styles["social-share__link"]} ${styles["social-newsletter__icon"]}`}
            >
              <Icon type="share-alt" className={`${styles["share-svg"]}`} />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

SocialShareTemplate.propTypes = {
  className: PropTypes.string,
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  handleShare: PropTypes.func,
  handleClickView: PropTypes.func,
  color: PropTypes.string,
  story: PropTypes.shape(),
  fullUrl: PropTypes.string
};
